import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CurrentBasketService } from 'src/app/basket/services/current-basket.service';
import { IBase, IBaseSearchRequest, IGridResult } from 'src/app/core/models/base';
import { IProduct } from '../models/product';
import { ProductService } from '../services/product.service';

@UntilDestroy()
@Component({
    selector: 'app-product-view',
    templateUrl: './product-view.component.html',
    styleUrls: ['./product-view.component.scss'],
    standalone: false
})
export class ProductViewComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private currentBasketService : CurrentBasketService
  ) {
   }

  public currentCompany$ =
    this.currentBasketService.currentCompany$;

  @Input() showActionColumn: boolean;

  ngOnInit(): void {
  }

}
